// import React, { useState } from "react";
// import axios from "axios";
// import "./ChangePassword.css";

// function ChangePassword() {
//   const [form, setForm] = useState({
//     oldPassword: "",
//     newPassword: "",
//     confirmPassword: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [msg, setMsg] = useState("");
//   const [error, setError] = useState("");

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setMsg("");
//     setError("");

//     if (form.newPassword !== form.confirmPassword) {
//       return setError("New password and confirm password must match");
//     }

//     try {
//       setLoading(true);

//       const token = localStorage.getItem("token");

//       const res = await axios.post(
//         `${process.env.REACT_APP_API_BASEURL}/admin/change-password`,
//         {
//           oldPassword: form.oldPassword,
//           newPassword: form.newPassword,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       setMsg(res.data.msg || "Password updated successfully");
//       setForm({
//         oldPassword: "",
//         newPassword: "",
//         confirmPassword: "",
//       });

//     } catch (err) {
//       setError(
//         err.response?.data?.msg || "Something went wrong. Try again."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="cp-container">
//       <div className="cp-card">
//         <h2>Change Password</h2>

//         <form onSubmit={handleSubmit}>
//           <div className="cp-input-group">
//             <label>Old Password</label>
//             <input
//               type="password"
//               name="oldPassword"
//               value={form.oldPassword}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="cp-input-group">
//             <label>New Password</label>
//             <input
//               type="password"
//               name="newPassword"
//               value={form.newPassword}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="cp-input-group">
//             <label>Confirm Password</label>
//             <input
//               type="password"
//               name="confirmPassword"
//               value={form.confirmPassword}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           {error && <p className="cp-error">{error}</p>}
//           {msg && <p className="cp-success">{msg}</p>}

//           <button type="submit" disabled={loading}>
//             {loading ? "Updating..." : "Update Password"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default ChangePassword;








import React, { useState } from "react";
import axios from "axios";

function ChangePassword() {
  const [form, setForm] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setError("");

    if (form.newPassword !== form.confirmPassword) {
      return setError("New password and confirm password must match");
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${process.env.REACT_APP_API_BASEURL}/admin/change-password`,
        {
          oldPassword: form.oldPassword,
          newPassword: form.newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setMsg(res.data.msg || "Password updated successfully");
      setForm({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (err) {
      setError(err.response?.data?.msg || "Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Change Password</h2>

        <form onSubmit={handleSubmit}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Old Password</label>
            <input
              type="password"
              name="oldPassword"
              value={form.oldPassword}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>New Password</label>
            <input
              type="password"
              name="newPassword"
              value={form.newPassword}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>

          {error && <p style={styles.error}>{error}</p>}
          {msg && <p style={styles.success}>{msg}</p>}

          <button
            type="submit"
            disabled={loading}
            style={styles.submitBtn}
          >
            {loading ? "Updating..." : "Update Secure Password 🔐"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword;

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #0f172a, #020617)",
    fontFamily: "Inter, sans-serif",
  },

  card: {
    width: "400px",
    padding: "30px",
    borderRadius: "20px",
    background: "rgba(255,255,255,0.05)",
    backdropFilter: "blur(15px)",
    boxShadow: "0 8px 40px rgba(0,0,0,0.4)",
    color: "#fff",
    transition: "0.3s",
  },

  title: {
    textAlign: "center",
    marginBottom: "25px",
    fontWeight: "600",
  },

  inputGroup: {
    marginBottom: "18px",
  },

  label: {
    fontSize: "14px",
    marginBottom: "6px",
    display: "block",
    color: "#cbd5f5",
  },

  input: {
    width: "100%",
    padding: "12px",
    borderRadius: "10px",
    border: "none",
    outline: "none",
    background: "rgba(255,255,255,0.08)",
    color: "#fff",
    fontSize: "14px",
  },

  submitBtn: {
    width: "100%",
    padding: "12px",
    borderRadius: "10px",
    border: "none",
    background: "linear-gradient(135deg, #6366f1, #4f46e5)",
    color: "#fff",
    fontWeight: "600",
    cursor: "pointer",
    marginTop: "10px",
  },

  error: {
    color: "#f87171",
    textAlign: "center",
    fontSize: "13px",
  },

  success: {
    color: "#4ade80",
    textAlign: "center",
    fontSize: "13px",
  },
};